export default __webpack_public_path__ + "static/media/motorway.617fa010.svg";